import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmSelectModule, EmMoreInfoModule, EmInputModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-best-price-filter',
  templateUrl: './best-price-filter.component.html',
  styleUrls: ['./best-price-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmSelectModule,
    EmSelectOperandModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatIconModule,
    EmMoreInfoModule,
    EmInputModule,
  ],
})
export class EmBestPriceFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
